const common = {
  white: '#FFFFFF',
  bg: '#FAFAFA'
};

export { common };
